import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'baf-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  message = 'Trwa ładowanie aplikacji...';

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts